import type { Command } from '../types/command';

/**
 * Bucket label for a command's per-command shortcut in the
 * keyboard-shortcuts dialog. Mirrors the palette's activation rule:
 *
 *   - `action` with `run`    -> 'Commands'   (executes the callback)
 *   - `action` without `run` -> 'Containers' (enters as a root)
 *   - `link`                 -> 'Commands'   (navigates)
 *
 * Scope-vs-leaf is decided by the presence of `run`, not by a
 * runtime hasChildren check on the registry. A parent that registers
 * children lazily (after scope entry) is still correctly categorized
 * as "Containers" because its declaration omits `run`.
 *
 * If/when the keyboard-shortcuts dialog adopts richer grouping
 * (e.g. by `section.label` so groups map to palette sections), this
 * function is the single replacement point.
 */
export function getShortcutCategory(command: Command): 'Containers' | 'Commands' {
  if (command.type === 'action' && !command.run) {
    return 'Containers';
  }
  return 'Commands';
}
